import { createContext, useContext } from 'react';

export const PreviewModeContext = createContext({ previewMode: false, setPreviewMode: () => null });
export const usePreviewMode = () => useContext(PreviewModeContext);
